import { render, staticRenderFns } from "./BasicReport.vue?vue&type=template&id=5a635f5c&lang=pug&"
import script from "./BasicReport.vue?vue&type=script&lang=ts&"
export * from "./BasicReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports